// Kept in sync with LANGUAGE_OPTIONS in
// pluginbackendnode/common/languageOptions.js — no shared config layer between
// the two repos.
export const LANGUAGE_OPTIONS = [
    "Hindi",
    "English",
    "Bengali",
    "Telugu",
    "Marathi",
    "Tamil",
    "Urdu",
    "Gujarati",
    "Kannada",
    "Odia",
    "Malayalam",
    "Punjabi",
    "Assamese",
    "Maithili",
    "Sanskrit",
    "Kashmiri",
    "Nepali",
    "Konkani",
    "Sindhi",
    "Dogri",
    "Manipuri",
    "Bodo",
    "Santali",
    "Rajasthani",
    "Bhojpuri",
    "Spanish",
    "French",
    "Arabic",
    "Mandarin Chinese",
    "Portuguese",
    "German",
    "Japanese",
    "Korean",
    "Russian",
    "Italian",
];
